import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getCollectionData } from "../../store/collectionImagesSlice/collection-images-actions";
import ImageItem from "./ImageItem";

import classes from "./ImageGrid.module.css";
import LoadingSpinner from "../UI/LoadingSpinner";

const ImageGrid = () => {
  const dispatch = useDispatch();
  const imageData = useSelector(
    (state) => state.collectionImages.collectionImages
  );
  const status = useSelector((state) => state.collectionImages.loading);

  useEffect(() => {
    dispatch(getCollectionData("Editorial"));
  }, [dispatch]);

  if (status) {
    return <LoadingSpinner />;
  } else {
    return (
      <div className={classes.container}>
        {imageData.map((image) => (
          <ImageItem
            key={image.id}
            id={image.id}
            url={image.urls.regular}
            username={image.user.username}
            name={image.user.name}
            link={image.user.links.html}
          />
        ))}
      </div>
    );
  }
};

export default ImageGrid;
